import GenericListItemButton from './MenuItemWithSubmenu';
import GenericCollapse from './GenericCollapse';
import GenericNavListItem from './GenericNavListItem';
import { ReactComponent as SubmenuIcon } from '../../../../../assets/icons/Navegation/submenu-flecha.svg';
import { triangle, headerTitleStyle } from '../Styles/StylesIcons';
import Popover from '@mui/material/Popover';
import Divider from '@mui/material/Divider';

const TriangleIcon = (props) => <SubmenuIcon style={triangle} {...props} />;

const MarketingMenu = ({
  userPermissions,
  handleClick,
  IconComponent,
  openMenu,
  activeStyle,
  drawerOpen,
  header,
  handlePopoverOpen,
  handlePopoverClose,
  openPopover,
  anchorEl,
}) => {
  const submenuContent = (
    <>
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='MARKETING_REPORTS'
        to='/kpis/marketing'
        title='Canal/campañas'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='MARKETING_REPORTS'
        to='/kpis/marketing/status-lead'
        title='Status de lead'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
      <GenericNavListItem
        userPermissions={userPermissions}
        permission='MARKETING_REPORTS'
        to='/kpis/marketing/paquetes-ipb'
        title='Paquetes IPB'
        IconComponent={TriangleIcon}
        activeStyle={activeStyle}
      />
    </>
  );

  return (
    <>
      {userPermissions?.includes('MARKETING_REPORTS') && (
        <>
          <Divider style={{ margin: '0 0 4px 0' }} />
          {drawerOpen && (
            <>
              {header?.marketing.kind === 'header' && (
                <div style={headerTitleStyle}>{header.marketing.title}</div>
              )}
            </>
          )}
          <GenericListItemButton
            onClick={drawerOpen ? handleClick : handlePopoverOpen}
            className={'layout-menu-submenu'}
            title='KPIs'
            IconComponent={IconComponent}
            openMenu={openMenu}
          />
          {drawerOpen && (
            <GenericCollapse
              className={'layout-menu-submenu-options'}
              openMenu={openMenu}
              userPermissions={userPermissions}
            >
              {submenuContent}
            </GenericCollapse>
          )}
          {!drawerOpen && (
            <Popover
              open={openPopover}
              anchorEl={anchorEl}
              onClose={handlePopoverClose}
              onBlur={handlePopoverClose}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              PaperProps={{
                style: { minWidth: 220 },
                onMouseLeave: handlePopoverClose,
              }}
            >
              <div style={{ padding: 8 }}>{submenuContent}</div>
            </Popover>
          )}
        </>
      )}
    </>
  );
};

export default MarketingMenu;
